import { Link } from 'react-router-dom';

export default function Hero() {
  const mainSiteUrl = 'https://kaspreadsheet.com';

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20minimalist%20fashion%20editorial%20scene%20with%20curated%20clothing%20rack%20featuring%20varied%20textures%20of%20sneakers%20hoodies%20bags%20and%20accessories%20arranged%20against%20a%20warm%20cream%20wall%2C%20soft%20diffused%20overhead%20lighting%20casting%20gentle%20shadows%2C%20modern%20boutique%20aesthetic%2C%20neutral%20beige%20and%20oatmeal%20tones%2C%20clean%20Scandinavian-inspired%20interior%2C%20lifestyle%20fashion%20photography%20with%20negative%20space%2C%20sophisticated%20yet%20approachable%20atmosphere&width=1600&height=900&seq=hero-superbuy-v2-july-2026&orientation=landscape"
          alt="Superbuy Spreadsheet fashion finds"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 text-center pt-16">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/90 backdrop-blur-sm border border-background-200/40 text-xs md:text-sm font-medium text-foreground-700 mb-6 md:mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          Updated Daily · Thousands of Verified Finds
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-[1.08] mb-4 md:mb-6">
          Superbuy<br />
          Spreadsheet<br />
          <span className="text-accent-300">Fashion Finds</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-[600px] mx-auto mb-8 md:mb-10 leading-relaxed">
          Explore thousands of verified products, trusted shopping guides, QC tutorials,
          shipping tips and buying resources — updated every day for smart shoppers worldwide.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 hover:-translate-y-0.5 transition-all duration-200 cursor-pointer flex items-center justify-center gap-2"
          >
            buy it now
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-950 text-base font-semibold hover:bg-background-50 hover:-translate-y-0.5 transition-all duration-200 cursor-pointer flex items-center justify-center gap-2"
          >
            superbuy sheet
            <i className="ri-external-link-line"></i>
          </a>
          <Link
            to="/superbuy-spreadsheet-guide"
            className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full border border-background-50/40 text-background-50 text-base font-medium hover:bg-background-50/10 hover:-translate-y-0.5 transition-all duration-200 cursor-pointer flex items-center justify-center gap-2"
          >
            Read Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4 max-w-[700px] mx-auto">
          {[
            { icon: 'ri-refresh-line', label: 'Updated Daily' },
            { icon: 'ri-check-double-line', label: 'Thousands of Finds' },
            { icon: 'ri-shield-check-line', label: 'Verified Resources' },
            { icon: 'ri-guide-line', label: 'QC & Shipping Guides' },
          ].map((item) => (
            <div
              key={item.label}
              className="flex flex-col items-center gap-2 p-3 md:p-4 rounded-xl bg-background-50/10 backdrop-blur-sm border border-background-50/15"
            >
              <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center">
                <i className={`${item.icon} text-lg md:text-xl text-accent-300`}></i>
              </div>
              <span className="text-xs md:text-sm text-background-50/80 font-medium whitespace-nowrap">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-background-50/60"></i>
      </div>
    </section>
  );
}